import Swiper from 'swiper';
import {Pagination, A11y, Keyboard, Autoplay} from "swiper/modules";
//import {enable} from "core-js/internals/internal-metadata";

if(document.querySelectorAll('.logo-wall-slider')) {
    (async function () {

        const sliderElements = document.querySelectorAll('.logo-wall-slider');

        if (sliderElements.length === 0) {
            return false;
        }

        sliderElements.forEach(slider => {
            const sliderElementsParent = slider.parentElement.parentElement;
            if (sliderElementsParent.className.indexOf('app-site-content-section') > -1) {
                sliderElementsParent.className = sliderElementsParent.className + " app-site-content-section-swiper";
            }
            const swiper = new Swiper(slider.querySelector('.swiper'), {
                slidesPerView: 2,
                slidesPerGroup: 2,
                breakpoints: {
                    641: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                    1025: {
                        slidesPerView: 6,
                        slidesPerGroup: 6,
                    },
                },
                loop: true,
                spaceBetween: 24,
                modules: [Pagination, A11y, Keyboard, Autoplay],
                autoplay: {
                    delay: parseInt(slider.dataset?.interval) || 3000,
                    disableOnInteraction: true
                },
                keyboard: {
                    enabled: true
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true
                }
            })
        });

    })();
}
